<template>
  <div>
     <v-layout wrap>
      <v-flex md3 xs12>
        <SellerDashboard></SellerDashboard>
      </v-flex>
       <v-flex md9 xs12>
    <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
      <v-row>
        <v-col md="3"></v-col>
        <v-col md="6">
          <h2 style="text-align:center;color:black;">
            <b class="prfont">Edit Product</b>
          </h2>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Product Name"
              prepend-icon="mdi-domain"
              type="text"
              class="form-control"
              id="productname"
              v-model="product.productname"
              :rules="nameRules"
              required
            />

            <v-text-field
              prepend-icon="mdi-currency-inr"
              label="Product Cost"
              type="text"
              class="form-control"
              id="productcost"
              v-model="product.productcost"
              :rules="costRules"
              required
            />
            <v-radio-group
              v-model="product.instock"
              prepend-icon="mdi-image-broken"
              label="Instock"
              row
              :rules="stockRules"
            >
              <v-radio label="Yes" value="true"></v-radio>
              <v-radio label="No" value="false"></v-radio>
            </v-radio-group>
            <!-- <label for="unit">Instock</label>
                      <v-select
                       prepend-icon=" mdi-clipboard-alert"
           :items="instocks"
                    v-model="product.instock"
                      :rules="stockRules"
            ></v-select>-->

            <v-text-field
              prepend-icon="mdi-clipboard-text"
              label="Description"
              type="text"
              class="form-control"
              id="description"
              v-model="product.description"
              :rules="descRules"
              required
            />
            <label for="unit">Unit Type</label>
            <v-select
              prepend-icon="mdi-hexagon-outline"
              :items="unittypes"
              v-model="product.unit"
              :rules="unitRules"
            ></v-select>

            <label for="unit">Tax Type</label>
            <v-select prepend-icon="mdi-dice-3" :items="taxtypes" v-model="tax" :rules="typeRules"></v-select>
            <label for="tax">Tax Amount</label>
            <v-text-field
              prepend-icon="mdi-currency-inr"
              type="text"
              disabled
              class="form-control"
              id="tax"
              v-model="product.tax"
              required
              :rules="taxRules"
            />

            <label for="unit">Commission</label>
            <v-text-field
              prepend-icon="mdi-dice-1"
              type="text"
              disabled
              class="form-control"
              id="comission"
              v-model="product.comission"
              :rules="commRules"
            />
            <label for="unit">Price</label>
            <v-text-field
              prepend-icon="mdi-currency-inr"
              type="text"
              disabled
              class="form-control"
              id="price"
              :rules="priceRules"
              v-model="product.price"
            />

            <v-radio-group
              v-model="product.isseasonal"
              prepend-icon="mdi-image-broken"
              label="Isseasonal"
              row
            >
              <v-radio label="Yes" value="true"></v-radio>
              <v-radio label="No" value="false"></v-radio>
            </v-radio-group>

            <v-radio-group
              v-model="product.isinseason"
              prepend-icon="mdi-image-broken"
              label="isinseason"
              row
            >
              <v-radio label="Yes" value="true"></v-radio>
              <v-radio label="No" value="false"></v-radio>
            </v-radio-group>

            <v-layout wrap justify-center>
              <v-flex xs12 md12 pt-2 text-center>
                <v-btn
                  rounded
                  :disabled="false"
                  width="500px"
                  class="text-capitalize hh"
                  dark
                  :ripple="false"
                  color="#26af82"
                  @click="editProduct"
                >Submit</v-btn>
              </v-flex>
            </v-layout>
            <br />

            <!-- <v-card-actions>
                <v-btn color="red" text @click="signindialog = false">Cancel</v-btn>
                <v-spacer />
                <v-btn color="#0e4e35" text @click="reginit">Signup</v-btn>
            </v-card-actions>-->
          </v-form>
        </v-col>
      </v-row>
    </v-card>
       </v-flex>
     </v-layout>
    <br />
  </div>
</template>
<script>
import axios from "axios";
import SellerDashboard from "@/components/common/SellerDashboard";
export default {
  components: {
    SellerDashboard
  },
  props: ["id"],
  data() {
    return {
      data: {},
      visible: false,
      product: [],
      productname: null,
      price: null,
      instock: null,
      description: null,
      unit: null,
      productcost: null,
      comission: null,
      tax: null,
      taxid: null,
      isseasonal: null,
      isinseason: null,
      tax: null,
      taxid: null,
      taxtype: [],
      taxtypes: [],
      taxtypesid: [],
      instocks: [true, false],
      unittypes: ["Count", "Kg", "gm", "litre"],
      gender: ["Male", "Female"],
      msg: null
    };
  },
  beforeMount() {
    this.getTax();
    this.getProductData();
  },
  watch: {
    tax: function() {
      if (this.product.productcost != null) {
        for (var j = 0; j < this.taxtype.length; j++) {
          if (this.tax === this.taxtypes[j]) {
            this.taxid = this.taxtypesid[j];
            this.product.taxid = this.taxtypesid[j];
          }
        }
        this.calcTax();
        // console.log(this.taxid)
      } else {
        alert("Please Provide Product Cost");
      }
    }
  },
  methods: {
    getProductData() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/product/info",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          id: this.id
        }
      })
        .then(response => {
          this.product = response.data.data;
          for (var j = 0; j < this.taxtype.length; j++) {
            if (this.product.taxid === this.taxtypesid[j]) {
              this.tax = this.taxtypes[j];
              this.product.tax = this.taxtypes[j];
            }
          }
          this.visible = false;
        })
        .catch(e => {
          console.log(e);
          this.msg = "failed";
          this.visible = false;
        });
    },
    getTax() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/tax/all",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          // console.log(response)
          this.visible = false;
          this.taxtype = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.taxtype.length; i++) {
            var ty = this.taxtype[i].name;
            var tyid = this.taxtype[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.taxtypes = temp;
          this.taxtypesid = tempid;
        })
        .catch(err => {
          console.log(err);
          this.visible = false;
        });
    },
    calcTax() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/product/calculateprice",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          taxid: this.taxid,
          productcost: this.product.productcost
        }
      })
        .then(response => {
          // console.log(response)
          this.product.tax = response.data.data.tax;
          this.product.price = response.data.data.price;
          this.product.comission = response.data.data.commision;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
          this.visible = false;
        });
    },
    editProduct() {
      this.visible = true;
      this.product.productcost = Number(this.product.productcost);
      // this.product.productid = this.id
      var data = {};

      data["productname"] = this.product.productname;
      data["price"] = this.product.price;
      data["instock"] = this.product.instock;
      data["description"] = this.product.description;
      data["unit"] = this.product.unit;
      data["productcost"] = this.product.productcost;
      data["commision"] = this.product.commision;
      data["tax"] = this.product.tax;
      data["taxid"] = this.product.taxid;
      data["isseasonal"] = this.product.isseasonal;
      data["isinseason"] = this.product.isinseason;

      data["id"] = this.id;

      console.log(data);
      axios({
        method: "POST",
        url: "/Product/Edit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: data
      })
         .then(response => {
            if (response.data.status == true) {
              this.id = response.data.id;
              this.msg = "Product added successfully";
              this.$dlg.alert(
                this.msg,
                () => {
                  // this.$router.push("/ImageUpload/" + this.vid);
                  this.$router.push("/AddShipping/" + this.id);
                  // this.$router.push("/productlist/");
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
    }
  }
};
</script>
<style>
.main-panel {
  width: calc(100% - 0px);
  min-height: calc(100vh - 58px);
}
.auth .auth-form-dark {
  background: white;
  color: black;
}
.content-wrapper {
  background: #dee2e6;
}
.auth .auth-form-dark .form-control {
  border-color: rgba(255, 255, 255, 0.2);
  color: black;
}
.auth .auth-form-dark .form-control {
  border-color: #212529;
  color: black;
}
.vs__selected-options input {
  border-color: #fff !important;
}
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
.prfont {
  font-family: "Montserrat";
}
</style>
